const colorTypeHelper = {
  'Alice Blue': '--blue-fourth',
  Azure: '--blue-secondary',
  'Background Image': '--transparent',
  Black: '--tertiary-color',
  'Blue 1': '--blue-1',
  'Blue 3': '--blue-3',
  'Blue 5 (Primary)': '--blue-5',
  'Blue 6': '--blue-6',
  'Blue 7': '--blue-7',
  'Blue Video': '--blue-video',
  'Bright Blue': '--blue-primary',
  'Bright Neutral': '--neutral-1',
  'Choose a value': '--transparent',
  'Dark Blue': '--blue-tertiary',
  'Dark Gray': '--gray-dark',
  Gray: '--dark-gray-color',
  'Green 5 (Primary)': '--green-5',
  'Green 6': '--green-6',
  'Green 7': '--green-7',
  'Light Gray': '--neutral-text-color',
  'Medium Blue': '--blue-secondary',
  'Neutral 1': '--neutral-1',
  'Neutral 2': '--neutral-2',
  'Neutral 4': '--neutral-4',
  'Neutral 5 (Primary)': '--neutral-5',
  'Neutral 6': '--neutral-6',
  'Neutral 7': '--neutral-7',
  Orange: '--primary-color',
  'Orange 5 (Primary)': '--orange-5',
  'Orange 6': '--orange-6',
  'Orange 7': '--orange-7',
  'Pro Products: Gray': '--gray-dark',
  Prussian: '--blue-tertiary',
  Purple: '--purple',
  Red: '--red',
  'Sky Blue': '--blue-primary',
  'Standard Blue': '--blue-primary',
  'Teal 5 (Primary)': '--teal-5',
  'Teal 6': '--teal-6',
  'Teal 7': '--teal-7',
  Transparent: '--transparent',
  White: '--white-color',
};

export default colorTypeHelper;
